var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhotoStudentSite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3610_116717)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.2099 6.45669L4.19029 20.2202C1.39359 20.7547 -0.442238 23.4549 0.092644 26.2539L10.4142 80.2634C10.9488 83.0601 13.6514 84.8954 16.4479 84.361L73.0885 73.5367C84.3792 71.379 91.7839 60.4754 89.6262 49.1846L82.2438 10.5542C81.7087 7.75516 79.0089 5.9218 76.2099 6.45669Z",
    fill: "url(#paint0_linear_3610_116717)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2469 10.5541C81.7121 7.75514 79.0122 5.92161 76.2132 6.4565L7.29688 19.627V25.6374H85.1294L82.2469 10.5541Z",
    fill: "url(#paint1_linear_3610_116717)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1854 15.6346L4.19029 20.2202C1.39359 20.7547 -0.442238 23.4549 0.092644 26.2539L10.4142 80.2634C10.9488 83.0601 13.6514 84.8954 16.4479 84.3611L73.0885 73.5365C76.4663 72.891 79.4956 71.4621 82.0258 69.4751L28.1854 15.6346Z",
    fill: "url(#paint2_linear_3610_116717)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.66 19.3982H8.33704C5.48969 19.3982 3.17969 21.7059 3.17969 24.5555V79.5424C3.17969 82.3895 5.48986 84.6997 8.33704 84.6997H66.0025C77.4976 84.6997 86.8174 75.38 86.8174 63.8848V24.5555C86.8174 21.7057 84.5099 19.3982 81.66 19.3982Z",
    fill: "url(#paint3_linear_3610_116717)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.66 19.3982H8.33704C5.48969 19.3982 3.17969 21.7059 3.17969 24.5555V79.5424C3.17969 82.3895 5.48986 84.6997 8.33704 84.6997H66.0025C77.4976 84.6997 86.8174 75.38 86.8174 63.8848V24.5555C86.8174 21.7057 84.5099 19.3982 81.66 19.3982Z",
    fill: "url(#paint4_linear_3610_116717)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8465 25.2318H13.1447C10.6711 25.2318 8.66406 27.1271 8.66406 29.4676V74.6302C8.66406 76.9688 10.6711 78.866 13.1447 78.866H63.2436C73.2302 78.866 81.3272 71.2112 81.3272 61.7701V29.4676C81.3272 27.1271 79.3224 25.2318 76.8465 25.2318Z",
    fill: "url(#paint5_linear_3610_116717)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0986 71.3988H51.6178C50.94 71.3988 50.3906 70.8494 50.3906 70.1716C50.3906 63.6244 55.6982 58.3168 62.2456 58.3168H69.471C76.0182 58.3168 81.3259 63.6244 81.3259 70.1716C81.3259 70.8494 80.7764 71.3988 80.0986 71.3988Z",
    fill: "url(#paint6_linear_3610_116717)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0986 71.3988H51.6178C50.94 71.3988 50.3906 70.8494 50.3906 70.1716C50.3906 63.6244 55.6982 58.3168 62.2456 58.3168H69.471C76.0182 58.3168 81.3259 63.6244 81.3259 70.1716C81.3259 70.8494 80.7764 71.3988 80.0986 71.3988Z",
    fill: "url(#paint7_linear_3610_116717)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3906 70.1716C50.3906 70.8494 50.94 71.3987 51.6178 71.3987H80.0987C80.7766 71.3987 81.3259 70.8494 81.3259 70.1716C81.3259 68.6998 81.057 67.291 80.5667 65.9908H51.1498C50.6596 67.2912 50.3906 68.6998 50.3906 70.1716Z",
    fill: "url(#paint8_linear_3610_116717)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8611 61.0405C60.3114 61.0405 55.8125 56.5415 55.8125 50.9919V45.8387C55.8125 40.2891 60.3114 35.7902 65.8611 35.7902C71.4107 35.7902 75.9097 40.2891 75.9097 45.8387V50.9919C75.9097 56.5415 71.4107 61.0405 65.8611 61.0405Z",
    fill: "url(#paint9_linear_3610_116717)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8611 61.0405C60.3114 61.0405 55.8125 56.5415 55.8125 50.9919V45.8387C55.8125 40.2891 60.3114 35.7902 65.8611 35.7902C71.4107 35.7902 75.9097 40.2891 75.9097 45.8387V50.9919C75.9097 56.5415 71.4107 61.0405 65.8611 61.0405Z",
    fill: "url(#paint10_linear_3610_116717)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.372 71.3988H9.89124C9.21342 71.3988 8.66406 70.8494 8.66406 70.1716C8.66406 63.6244 13.9716 58.3168 20.519 58.3168H27.7446C34.2918 58.3168 39.5995 63.6244 39.5995 70.1716C39.5992 70.8494 39.0498 71.3988 38.372 71.3988Z",
    fill: "url(#paint11_linear_3610_116717)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.372 71.3988H9.89124C9.21342 71.3988 8.66406 70.8494 8.66406 70.1716C8.66406 63.6244 13.9716 58.3168 20.519 58.3168H27.7446C34.2918 58.3168 39.5995 63.6244 39.5995 70.1716C39.5992 70.8494 39.0498 71.3988 38.372 71.3988Z",
    fill: "url(#paint12_linear_3610_116717)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.66406 70.1716C8.66406 70.8494 9.21342 71.3987 9.89124 71.3987H38.3722C39.05 71.3987 39.5994 70.8494 39.5994 70.1716C39.5994 68.6998 39.3304 67.291 38.8402 65.9908H9.42306C8.933 67.2912 8.66406 68.6998 8.66406 70.1716Z",
    fill: "url(#paint13_linear_3610_116717)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1345 61.0405C18.5849 61.0405 14.0859 56.5415 14.0859 50.9919V45.8387C14.0859 40.2891 18.5849 35.7902 24.1345 35.7902C29.6842 35.7902 34.1831 40.2891 34.1831 45.8387V50.9919C34.1831 56.5415 29.6842 61.0405 24.1345 61.0405Z",
    fill: "url(#paint14_linear_3610_116717)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1345 61.0405C18.5849 61.0405 14.0859 56.5415 14.0859 50.9919V45.8387C14.0859 40.2891 18.5849 35.7902 24.1345 35.7902C29.6842 35.7902 34.1831 40.2891 34.1831 45.8387V50.9919C34.1831 56.5415 29.6842 61.0405 24.1345 61.0405Z",
    fill: "url(#paint15_linear_3610_116717)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1376 78.8661H27.8522C27.0364 78.8661 26.375 78.2047 26.375 77.3889C26.375 69.5073 32.7643 63.1179 40.646 63.1179H49.3441C57.2256 63.1179 63.6151 69.5072 63.6151 77.3889C63.6149 78.2047 62.9535 78.8661 62.1376 78.8661Z",
    fill: "url(#paint16_linear_3610_116717)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.375 77.3887C26.375 78.2045 27.0364 78.866 27.8522 78.866H62.1376C62.9535 78.866 63.6149 78.2045 63.6149 77.3887C63.6149 75.617 63.2911 73.9213 62.7011 72.356H27.2888C26.6988 73.9213 26.375 75.6171 26.375 77.3887Z",
    fill: "url(#paint17_linear_3610_116717)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9981 70.9918C47.7801 70.9918 50.0353 69.0827 50.0353 66.7277C50.0353 64.3728 47.7801 62.4637 44.9981 62.4637C42.2162 62.4637 39.9609 64.3728 39.9609 66.7277C39.9609 69.0827 42.2162 70.9918 44.9981 70.9918Z",
    fill: "url(#paint18_linear_3610_116717)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9981 70.9918C47.7801 70.9918 50.0353 69.0827 50.0353 66.7277C50.0353 64.3728 47.7801 62.4637 44.9981 62.4637C42.2162 62.4637 39.9609 64.3728 39.9609 66.7277C39.9609 69.0827 42.2162 70.9918 44.9981 70.9918Z",
    fill: "url(#paint19_linear_3610_116717)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.875 50.9917C29.875 49.014 31.2478 47.3569 33.0924 46.9216C33.5855 46.8051 34.0568 47.1865 34.0568 47.6931V54.2903C34.0568 54.7969 33.5855 55.1783 33.0924 55.0618C31.2478 54.6263 29.875 52.9694 29.875 50.9917Z",
    fill: "url(#paint20_linear_3610_116717)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1115 50.9917C60.1115 49.014 58.7387 47.3569 56.8941 46.9216C56.401 46.8051 55.9297 47.1865 55.9297 47.6931V54.2903C55.9297 54.7969 56.401 55.1783 56.8941 55.0618C58.7387 54.6263 60.1115 52.9694 60.1115 50.9917Z",
    fill: "url(#paint21_linear_3610_116717)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.995 66.3967C38.3141 66.3967 32.8984 60.981 32.8984 54.3002V48.0969C32.8984 41.4163 38.3143 36.0004 44.995 36.0004C51.6756 36.0004 57.0915 41.4163 57.0915 48.0969V54.3002C57.0915 60.9808 51.6756 66.3967 44.995 66.3967Z",
    fill: "url(#paint22_linear_3610_116717)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6659 57.3426H44.3293C43.2154 57.3426 42.3722 56.336 42.5672 55.2394L43.3333 50.9324H46.6617L47.4277 55.2394C47.6231 56.3361 46.7797 57.3426 45.6659 57.3426Z",
    fill: "url(#paint23_linear_3610_116717)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.633 53.5945C38.6621 53.5945 37.875 52.8074 37.875 51.8365V50.9349C37.875 49.9639 38.6621 49.1769 39.633 49.1769C40.6039 49.1769 41.391 49.9639 41.391 50.9349V51.8365C41.391 52.8074 40.6039 53.5945 39.633 53.5945Z",
    fill: "url(#paint24_linear_3610_116717)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3596 53.5945C49.3886 53.5945 48.6016 52.8074 48.6016 51.8365V50.9349C48.6016 49.9639 49.3886 49.1769 50.3596 49.1769C51.3305 49.1769 52.1176 49.9639 52.1176 50.9349V51.8365C52.1176 52.8074 51.3305 53.5945 50.3596 53.5945Z",
    fill: "url(#paint25_linear_3610_116717)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7912 56.1926C41.5494 56.1926 43.7855 53.9566 43.7855 51.1983C43.7855 48.4401 41.5494 46.204 38.7912 46.204C36.0329 46.204 33.7969 48.4401 33.7969 51.1983C33.7969 53.9566 36.0329 56.1926 38.7912 56.1926Z",
    fill: "url(#paint26_linear_3610_116717)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1974 56.1926C53.9557 56.1926 56.1917 53.9566 56.1917 51.1983C56.1917 48.4401 53.9557 46.204 51.1974 46.204C48.4392 46.204 46.2031 48.4401 46.2031 51.1983C46.2031 53.9566 48.4392 56.1926 51.1974 56.1926Z",
    fill: "url(#paint27_linear_3610_116717)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7442 42.6321C60.7442 45.0565 60.0676 46.6423 59.1374 47.6767C57.3828 49.6283 54.1885 48.9343 53.2594 46.4799C52.1668 43.5937 49.5859 41.5661 46.5769 41.5661C46.494 41.5661 46.4111 41.5673 46.3281 41.5714C46.7981 37.6581 49.8321 34.6385 53.5045 34.6385C57.5035 34.6384 60.7442 38.2174 60.7442 42.6321Z",
    fill: "url(#paint28_linear_3610_116717)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1866 35.9958C56.0696 34.3708 55.1919 32.8849 53.8387 31.9777C52.201 30.8799 49.3987 29.9709 44.6089 29.9709C41.551 29.9709 39.3033 30.3415 37.6516 30.8951C36.534 31.2697 35.4062 31.6151 34.2586 31.8847C30.553 32.7554 27.8047 35.9458 27.8047 39.7491C27.8047 44.2226 31.6067 47.8493 36.297 47.8493C39.7468 47.8493 45.7045 41.6601 51.0127 41.6601C51.6718 41.6601 52.198 41.085 52.8005 40.8175C54.1147 40.2339 56.389 38.8098 56.1866 35.9958Z",
    fill: "url(#paint29_linear_3610_116717)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.17969 46.9022V79.542C3.17969 82.3906 5.48881 84.6998 8.33739 84.6998H66.0025C77.4985 84.6998 86.8179 75.3803 86.8179 63.8843V46.9022H3.17969Z",
    fill: "url(#paint30_linear_3610_116717)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66 84.6997V69.042C66 66.1934 68.3093 63.8843 71.1577 63.8843H86.8154C86.8154 75.3803 77.496 84.6997 66 84.6997Z",
    fill: "url(#paint31_linear_3610_116717)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4848 5.99488L18.1774 10.8771C18.6916 11.4122 19.4361 11.6598 20.1683 11.5396L26.8505 10.4418C28.6945 10.1388 30.0853 12.0817 29.2041 13.7296L26.0109 19.7012C25.661 20.3555 25.6555 21.1401 25.9961 21.7994L29.105 27.8153C29.9628 29.4754 28.5448 31.3985 26.7053 31.0698L20.0393 29.8781C19.3089 29.7475 18.5608 29.9846 18.0392 30.5125L13.2784 35.3282C11.9647 36.657 9.69742 35.9028 9.44172 34.0516L8.51507 27.3436C8.4136 26.6086 7.95672 25.9705 7.29372 25.6375L1.24254 22.5979C-0.427222 21.7592 -0.410458 19.3698 1.27095 18.5546L7.36431 15.6005C8.03207 15.2769 8.4976 14.6453 8.60948 13.9117L9.63037 7.21729C9.91219 5.37 12.1899 4.6477 13.4848 5.99488Z",
    fill: "url(#paint32_linear_3610_116717)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0217723 20.2712L0.020537 20.2761C-0.099463 21.1703 0.306243 22.1278 1.24224 22.5979L7.29342 25.6375C7.95642 25.9705 8.4133 26.6086 8.51477 27.3436L9.44142 34.0516C9.69713 35.9026 11.9644 36.657 13.2781 35.3282L18.0389 30.5125C18.5605 29.9848 19.3084 29.7477 20.039 29.8781L26.705 31.0698C28.5445 31.3985 29.9625 29.4754 29.1047 27.8153L25.9958 21.7994C25.873 21.5619 25.796 21.3081 25.763 21.0499L0.0217723 20.2712Z",
    fill: "url(#paint33_linear_3610_116717)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8605 11.1247L28.8644 11.128C29.478 11.7896 29.698 12.8059 29.2041 13.7296L26.0109 19.7012C25.6609 20.3555 25.6554 21.1401 25.996 21.7994L29.1049 27.8153C29.9627 29.4753 28.5448 31.3985 26.7053 31.0698L20.0393 29.878C19.3089 29.7475 18.5608 29.9846 18.0391 30.5125L13.2785 35.3282C11.9649 36.657 9.69756 35.9028 9.44185 34.0516L8.5152 27.3436C8.47867 27.0787 8.3952 26.8269 8.27344 26.5969L28.8605 11.1247Z",
    fill: "url(#paint34_linear_3610_116717)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.041 29.8781L26.707 31.0698C28.5465 31.3985 29.9645 29.4753 29.1066 27.8153L25.9977 21.7994C25.6572 21.1401 25.6626 20.3555 26.0126 19.7012L29.2058 13.7296C30.0869 12.0817 28.6962 10.1388 26.8522 10.4418L20.17 11.5396C19.4378 11.6599 18.6933 11.4122 18.179 10.8771L13.4867 5.99488C12.8392 5.32129 11.9461 5.16511 11.1797 5.40811L18.9629 29.9483C19.3062 29.8394 19.6759 29.8128 20.041 29.8781Z",
    fill: "url(#paint35_linear_3610_116717)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3610_116717",
    x1: 33.1406,
    y1: 20.4538,
    x2: 60.8852,
    y2: 72.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9B1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#814AA0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3610_116717",
    x1: 46.2132,
    y1: 12.7059,
    x2: 46.2132,
    y2: 21.9227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B3374",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B3374"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3610_116717",
    x1: 41.5766,
    y1: 67.1377,
    x2: 8.664,
    y2: 10.2884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B3374",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B3374"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3610_116717",
    x1: 24.1578,
    y1: 31.2073,
    x2: 84.9812,
    y2: 92.0307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3DAFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3610_116717",
    x1: 35.8262,
    y1: 30.5683,
    x2: 26.2753,
    y2: 8.20219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BACDF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0681AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3610_116717",
    x1: 29.1467,
    y1: 36.1993,
    x2: 56.9985,
    y2: 64.0511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3DAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BACDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3610_116717",
    x1: 62.1033,
    y1: 61.3047,
    x2: 66.8957,
    y2: 71.0391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3DAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BACDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3610_116717",
    x1: 60.603,
    y1: 58.7753,
    x2: 70.0936,
    y2: 77.0033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BACDF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0681AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3610_116717",
    x1: 65.8583,
    y1: 68.1825,
    x2: 65.8583,
    y2: 72.282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BACDF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0681AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3610_116717",
    x1: 58.0796,
    y1: 40.6339,
    x2: 70.1349,
    y2: 52.6892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3DAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BACDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3610_116717",
    x1: 58.9835,
    y1: 41.5378,
    x2: 76.5676,
    y2: 59.1219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BACDF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0681AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3610_116717",
    x1: 20.3768,
    y1: 61.3047,
    x2: 25.169,
    y2: 71.0391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3DAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BACDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3610_116717",
    x1: 18.8764,
    y1: 58.7753,
    x2: 28.367,
    y2: 77.0033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BACDF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0681AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3610_116717",
    x1: 24.1317,
    y1: 68.1825,
    x2: 24.1317,
    y2: 72.282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BACDF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0681AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3610_116717",
    x1: 16.3531,
    y1: 40.6339,
    x2: 28.4083,
    y2: 52.6892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3DAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BACDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3610_116717",
    x1: 17.2569,
    y1: 41.5378,
    x2: 34.841,
    y2: 59.1219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BACDF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0681AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_3610_116717",
    x1: 40.4748,
    y1: 66.7147,
    x2: 46.2436,
    y2: 78.433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02905D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_3610_116717",
    x1: 44.9951,
    y1: 74.9944,
    x2: 44.9951,
    y2: 79.9292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026841",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E5959"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_3610_116717",
    x1: 45.0241,
    y1: 65.2683,
    x2: 44.9692,
    y2: 68.3467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDFCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA78F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_3610_116717",
    x1: 44.9981,
    y1: 72.9556,
    x2: 44.9981,
    y2: 66.2892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89580",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9972,
    stopColor: "#C5715A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_3610_116717",
    x1: 31.1055,
    y1: 49.1836,
    x2: 34.4691,
    y2: 52.5473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDFCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA78F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_3610_116717",
    x1: 54.6261,
    y1: 48.5448,
    x2: 59.3329,
    y2: 53.2514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDFCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA78F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_3610_116717",
    x1: 36.874,
    y1: 45.7389,
    x2: 53.0101,
    y2: 56.5867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDFCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA78F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_3610_116717",
    x1: 44.9977,
    y1: 53.4126,
    x2: 44.9977,
    y2: 58.1586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89580",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9972,
    stopColor: "#C5715A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_3610_116717",
    x1: 38.4865,
    y1: 50.5419,
    x2: 40.9272,
    y2: 52.3385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_3610_116717",
    x1: 49.0939,
    y1: 50.4365,
    x2: 51.2636,
    y2: 52.0638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_3610_116717",
    x1: 35.3009,
    y1: 47.7083,
    x2: 44.4306,
    y2: 56.8378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_3610_116717",
    x1: 47.7072,
    y1: 47.7083,
    x2: 56.8367,
    y2: 56.8378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_3610_116717",
    x1: 51.7645,
    y1: 38.5573,
    x2: 57.1437,
    y2: 43.9363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_3610_116717",
    x1: 36.6443,
    y1: 33.2365,
    x2: 44.7319,
    y2: 41.3241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_3610_116717",
    x1: 44.9988,
    y1: 76.028,
    x2: 44.9988,
    y2: 88.5632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BACDF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0681AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_3610_116717",
    x1: 71.952,
    y1: 69.8363,
    x2: 78.4795,
    y2: 76.3637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3DAFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_3610_116717",
    x1: 7.29974,
    y1: 16.9067,
    x2: 25.6645,
    y2: 26.433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA613"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_3610_116717",
    x1: 14.559,
    y1: 25.7466,
    x2: 16.5673,
    y2: 6.68546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEA613",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E94444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_3610_116717",
    x1: 20.2093,
    y1: 23.8407,
    x2: 7.58927,
    y2: 9.41518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEA613",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E94444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_3610_116717",
    x1: 19.7426,
    y1: 18.0968,
    x2: 7.59338,
    y2: 29.3171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEA613",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E94444"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3610_116717"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoStudentSite);
export default __webpack_public_path__ + "static/media/photoStudentSite.9c52999e9a7d3eba4e25b1c132a5bf93.svg";
export { ForwardRef as ReactComponent };